import { Button, Modal } from '@hakimo-ui/shared/ui-base';

interface Props {
  remainingSeconds: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function IdleTimeoutWarningModal(props: Props) {
  const { remainingSeconds, onStayLoggedIn, onLogout } = props;

  const actions = (
    <>
      <Button variant="primary" onClick={onStayLoggedIn}>
        Stay Logged In
      </Button>
      <Button onClick={onLogout}>Log Out</Button>
    </>
  );

  return (
    <Modal
      open
      onClose={onStayLoggedIn}
      title="Session Timeout Warning"
      footer={actions}
    >
      <div className="p-6">
        <p className="text-gray-700 dark:text-gray-300">
          You will be logged out in{' '}
          <span className="font-semibold">{remainingSeconds}</span>{' '}
          {remainingSeconds === 1 ? 'second' : 'seconds'} due to inactivity.
        </p>
      </div>
    </Modal>
  );
}
